module.exports = __webpack_public_path__ + "media/images/make_it_switch_banner-e4f0d0d838b058b65a251ea4d7017d07.jpg";